var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-21120 -14833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 32,
    height: 32,
    transform: "translate(21120 14833)",
    fill: "#6fd231",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(21122 14835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4823",
    "data-name": "Path 4823",
    d: "M24.917,4.5H22.833V3.667a1.667,1.667,0,0,0-3.333,0V4.5H16.167V3.667a1.667,1.667,0,0,0-3.333,0V4.5H9.5V3.667a1.667,1.667,0,0,0-3.333,0V4.5H4.083A2.083,2.083,0,0,0,2,6.583V23.25a2.083,2.083,0,0,0,2.083,2.083H15.75a.417.417,0,1,0,0-.833H4.083a1.254,1.254,0,0,1-1.25-1.25V10.333H26.167v7.083a.417.417,0,1,0,.833,0V6.583A2.083,2.083,0,0,0,24.917,4.5Zm-4.583-.833a.833.833,0,0,1,1.667,0v2.5a.833.833,0,1,1-1.667,0Zm-6.667,0a.833.833,0,0,1,1.667,0v2.5a.833.833,0,1,1-1.667,0ZM7,3.667a.833.833,0,0,1,1.667,0v2.5A.833.833,0,1,1,7,6.167ZM26.167,9.5H2.833V6.583a1.254,1.254,0,0,1,1.25-1.25H6.167v.833a1.667,1.667,0,1,0,3.333,0V5.333h3.333v.833a1.667,1.667,0,1,0,3.333,0V5.333H19.5v.833a1.667,1.667,0,1,0,3.333,0V5.333h2.083a1.254,1.254,0,0,1,1.25,1.25Z",
    transform: "translate(0 0)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4824",
    "data-name": "Path 4824",
    d: "M25.333,27.833A.833.833,0,0,0,24.5,27H22.833a.833.833,0,0,0-.833.833v1.25a.833.833,0,0,0,.833.833H24.5a.833.833,0,0,0,.833-.833Zm-2.5,1.25v-1.25H24.5v1.25Z",
    transform: "translate(-11.667 -14.583)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4825",
    "data-name": "Path 4825",
    d: "M13.333,27.833A.833.833,0,0,0,12.5,27H10.833a.833.833,0,0,0-.833.833v1.25a.833.833,0,0,0,.833.833H12.5a.833.833,0,0,0,.833-.833Zm-2.5,1.25v-1.25H12.5v1.25Z",
    transform: "translate(-4.667 -14.583)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4826",
    "data-name": "Path 4826",
    d: "M48.5,29.917a.833.833,0,0,0,.833-.833v-1.25A.833.833,0,0,0,48.5,27H46.833a.833.833,0,0,0-.833.833v1.25a.833.833,0,0,0,.833.833Zm-1.667-2.083H48.5v1.25H46.833Z",
    transform: "translate(-25.667 -14.583)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4827",
    "data-name": "Path 4827",
    d: "M25.333,36.833A.833.833,0,0,0,24.5,36H22.833a.833.833,0,0,0-.833.833v1.25a.833.833,0,0,0,.833.833H24.5a.833.833,0,0,0,.833-.833Zm-2.5,1.25v-1.25H24.5v1.25Z",
    transform: "translate(-11.667 -19.833)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4828",
    "data-name": "Path 4828",
    d: "M13.333,36.833A.833.833,0,0,0,12.5,36H10.833a.833.833,0,0,0-.833.833v1.25a.833.833,0,0,0,.833.833H12.5a.833.833,0,0,0,.833-.833Zm-2.5,1.25v-1.25H12.5v1.25Z",
    transform: "translate(-4.667 -19.833)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4829",
    "data-name": "Path 4829",
    d: "M24.5,45H22.833a.833.833,0,0,0-.833.833v1.25a.833.833,0,0,0,.833.833H24.5a.833.833,0,0,0,.833-.833v-1.25A.833.833,0,0,0,24.5,45Zm-1.667,2.083v-1.25H24.5v1.25Z",
    transform: "translate(-11.667 -25.083)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4830",
    "data-name": "Path 4830",
    d: "M34.833,29.917H36.5a.833.833,0,0,0,.833-.833v-1.25A.833.833,0,0,0,36.5,27H34.833a.833.833,0,0,0-.833.833v1.25A.833.833,0,0,0,34.833,29.917Zm0-2.083H36.5v1.25H34.833Z",
    transform: "translate(-18.667 -14.583)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4831",
    "data-name": "Path 4831",
    d: "M34,38.083a.833.833,0,0,0,.833.833.417.417,0,1,0,0-.833v-1.25H36.5a.417.417,0,1,0,0-.833H34.833a.833.833,0,0,0-.833.833Z",
    transform: "translate(-18.667 -19.833)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4832",
    "data-name": "Path 4832",
    d: "M12.5,45H10.833a.833.833,0,0,0-.833.833v1.25a.833.833,0,0,0,.833.833H12.5a.833.833,0,0,0,.833-.833v-1.25A.833.833,0,0,0,12.5,45Zm-1.667,2.083v-1.25H12.5v1.25Z",
    transform: "translate(-4.667 -25.083)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4833",
    "data-name": "Path 4833",
    d: "M41.417,36a5.417,5.417,0,1,0,5.417,5.417A5.417,5.417,0,0,0,41.417,36Zm0,10A4.583,4.583,0,1,1,46,41.417,4.583,4.583,0,0,1,41.417,46Z",
    transform: "translate(-19.833 -19.833)",
    fill: "#0090f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4834",
    "data-name": "Path 4834",
    d: "M47.183,44.637l-3.241,3.241L42.469,46.4a.417.417,0,1,0-.589.589l1.768,1.768a.417.417,0,0,0,.589,0l3.535-3.535a.417.417,0,1,0-.589-.589Z",
    transform: "translate(-23.192 -24.8)",
    fill: "#0090f0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduling);
export default __webpack_public_path__ + "static/media/scheduling.a365a5cafb0f699ac2878282a6d7c71f.svg";
export { ForwardRef as ReactComponent };